<template>
<div>
  <div class="search-BG cursor-default" @click.stop="closeSearchBar"></div>
  <div class="SearchBar mobile-hidden text-NotoSansRegular" tabindex="0" :class="{ isSmall: isScroll }">
    <div class="search-container flex items-center justify-between md:border-l" tabindex="1">
      <div class="searchButton px-5 py-4 flex items-center cursor-pointer" @click.prevent.stop="searchItem">
        <font-awesome-icon icon="search" class="textColorDarkBlack" />
      </div>
      <input placeholder="請輸入關鍵字" type="text" class="m-0 text-sm text-NotoSansRegular" v-model="searchVal" spellcheck="false"
        v-on:keyup.13="searchItem" aria-label="請輸入關鍵字" v-on:keyup.40="keyCode" v-on:keyup.38="keyCode" v-on:input="autocomplete" v-focus>
      <a class="close-button px-5 py-4" @click.prevent.stop="closeSearchBar">
        <font-awesome-icon icon="times" class="textColorDarkBlack" />
      </a>
    </div>
    <div class="autocomplete inline-block absolute" v-if="autocompleteList && autocompleteList.length > 0">
      <ul>
        <li v-for="(item,index) in autocompleteList" :key="index">
          <a class="px-3 py-2 block border autoText text-NotoSansRegular text-sm"
          :class="{ keyFocus: idx === index }"
            @click.prevent.stop="autocompleteSearch(item)">
            {{ item }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'
import ga4 from '@/components/modules/ga4'
export default {
  name: 'SearchBarWeb',

  data () {
    return {
      searchVal: '',
      autocompleteList: null,
      idx: -1
    }
  },
  props: {
    isScroll: {
      type: Boolean
    }
  },
  mixins: [
    ga4
  ],
  watch: {
  },
  computed: {
  },
  mounted () {
  },
  updated () {
    // this.removeAutocomplete()
  },
  methods: {
    searchItem () {
      let self = this
      if (self.searchVal !== '') {
        self.$router.push({ name: 'SearchResult', query: { keyword: self.searchVal } })
        self.search_track(self.searchVal)
      }
      self.closeSearchBar()
    },
    autocompleteSearch (item) {
      let self = this
      self.searchVal = item
      self.autocompleteList = null
      self.$router.push({ name: 'SearchResult', query: { keyword: self.searchVal } })
      self.search_track(self.searchVal)
      self.closeSearchBar()
    },
    removeAutocomplete () {
      let self = this
      if (self.searchVal === self.$route.query.keyword) {
        self.autocompleteList = null
      }
    },
    autocomplete () {
      let self = this
      if (self.searchVal) {
        axios.get('/autocomplete/products?q=' + self.searchVal)
          .then((response) => {
            let list = []
            for (let item of response.data) {
              list.push(item.name)
            }
            self.autocompleteList = list
            self.idx = -1
          }
          )
      } else {
        self.autocompleteList = null
      }
    },
    closeSearchBar () {
      let self = this
      self.searchVal = null
      self.idx = -1

      self.$emit('closeSearchBar', false)
    },
    keyCode (e) {
      let self = this
      if (self.autocompleteList) {
        let length = self.autocompleteList.length
        // up
        if (e.which === 38 && self.idx < length && self.idx > 0) {
          self.idx--
          self.searchVal = self.autocompleteList[self.idx]
        }

        // down
        if (e.which === 40 && self.idx < length - 1) {
          self.idx++

          self.searchVal = self.autocompleteList[self.idx]
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .search-BG {
    transition: .2s;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 88;
    animation-name: bg;
    animation-duration: 0.2s;
    animation-fill-mode: forwards;
  }
  @keyframes bg {
    from {
      background: rgba(0, 0, 0, 0);
    }
    to {
      background: rgba(0, 0, 0, 0.35);
    }
  }
  .SearchBar {
    z-index:99;
    position: absolute;
    top: -1px;
    right: 0;
    outline: none;
    .search-container {
      background-color: #fff;
      overflow: hidden;
      height: 4.1rem;
      width: 4rem;

      animation-name: container;
      animation-duration: 0.35s;
      animation-fill-mode: forwards;
        &:focus {
          outline: none;
        }
      input {
        appearance: none;
        width: 0em;
        height: 2em;
        background: #fff;
        color: #6A5D4F;
        font-weight: 400;
        padding: 0px;
        border: 0;
        border-radius: 5px;
        &:focus {
          outline: none;
        }
        animation-name: input;
        animation-duration: 0.35s;
        animation-fill-mode: forwards;
      }
      .searchButton {
        color: #6A5D4F;
        text-align: center;
        // font-size: 1.5em;
        color: #FDF6E3;
        border-radius: 50%;
        i {
          margin-top: 0.3em;
          color: #6A5D4F;
        }
        &:active {
          border: 0 !important;
          text-shadow: 0 0 0;
        }
      }
    }

    .close-button {
      text-align: center;
      color: #FDF6E3;
      border-radius: 50%;
      i {
        margin-top: 0.3em;
        color: #6A5D4F;
      }
      &:active {
        border: 0 !important;
        text-shadow: 0 0 0;
      }
    }
    @keyframes container {
      from {width: 4em;}
      to {width: 28em;}
    }
    @keyframes input {
      from {
        display: none;
        width: 0em;
      }
      to {
        display: inline-block !important;
        width: 100%;
      }
    }
  }
  .isSmall {
    .search-container {
      height: 49px;
    }
  }
  .autocomplete {
    z-index: 1002;
    transition: left .3s ease-out;
    &::before {
      background-color: transparent !important;
      content: "";
      display: block;
      width: 0;
      height: 0;
      border-left: 11px solid transparent;
      border-right: 11px solid transparent;
      border-bottom: 11px solid;
      border-bottom-color: #fff;
      margin-left: 193px;
    }
    ul {
      li {
        background-color: white !important;
        .autoText {
          width: 32em;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          &:hover {
            background-color: #484848;
            color: white;
            border-color: #484848;
          }
        }
      }
    }
  }
  .keyFocus {
    background-color: #484848;
    color: white;
    border-color: #484848 !important;
  }

</style>
